import { useMemo } from "react";
import { useLocation } from "react-router";
import { readPropertyCheckContext } from "../../lib/propertyCheckNavigation";

export function usePropertyCheckContext() {
  const location = useLocation();
  return useMemo(
    () => readPropertyCheckContext(location.state),
    [location.state, location.key],
  );
}
